"use client";
import { useEffect } from "react";

import { useTracker } from "@ctv/core";
import { event, featurePageTracking } from "@ctv/shared/tracking/landing-page";

import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import FeatureList from "./components/FeatureList/FeatureList";
import Hero from "./components/Hero/Hero";
import Reason from "./components/Reason/Reason";

export default function Features() {
  const track = useTracker();

  useEffect(() => {
    track(event.CORPORATE_TRAVEL, featurePageTracking.PAGE);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only run once
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <Reason />
      <FeatureList />
      <Footer />
    </>
  );
}
